import {
  QueryFunctionContext,
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import {OrderData} from '../../../components/OrderManager/types/orderData'
import {fetchResponse} from './utils'

const fetchOrderData = ({queryKey}: QueryFunctionContext): Promise<UseQueryOptions> => {
  return fetchResponse(`/transactioncomposite/orders/${queryKey[1]}`)
}

// TODO we need to type the transactioncomposite response
export const useOrderData = (orderId: number): UseQueryResult<OrderData> => {
  return useQuery(['orderData', String(orderId)], fetchOrderData)
}
